import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/UploadTool.css';

const UploadTool = () => {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    author: '',
    category: '',
    tags: '',
    price: '',
    files: []
  });

  const categories = [
    'Risk Mitigation',
    'Strategic Planning',
    'Financial Modeling',
    'Sales Enablement',
    'Team Onboarding',
    'Compliance',
    'Fundraising',
    'AI Toolkits',
    'Forecasting'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFormData(prev => ({
        ...prev,
        files: Array.from(e.target.files || [])
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    try {
      // TODO: Implement file upload and tool creation
      console.log('Form submitted:', formData);
      navigate('/business-tool-marketplace');
    } catch (error) {
      console.error('Error uploading tool:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className='upload-tool-container'>
      <div className="upload-form">
        <div className="upload-form-card">
          <h1>Upload New Tool</h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="title">Tool Title</label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="Enter tool title"
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="description">Description</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                className="form-input"
                required
                rows={4}
                placeholder="Describe your tool"
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="author">Author</label>
              <input
                type="text"
                id="author"
                name="author"
                value={formData.author}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="Your name or company"
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="category">Category</label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                className="form-input"
                required
              >
                <option value="">Select a category</option>
                {categories.map(category => (
                  <option key={category} value={category}>{category}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="tags">Tags</label>
              <input
                type="text"
                id="tags"
                name="tags"
                value={formData.tags}
                onChange={handleInputChange}
                className="form-input"
                required
                placeholder="Enter tags separated by commas"
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="price">Price ($)</label>
              <input
                type="number"
                id="price"
                name="price"
                value={formData.price}
                onChange={handleInputChange}
                className="form-input"
                required
                min="0"
                step="0.01"
                placeholder="0.00"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Files</label>
              <div className="file-upload">
                <input
                  type="file"
                  id="files"
                  name="files"
                  onChange={handleFileChange}
                  className="file-upload-input"
                  multiple
                  required
                />
                <label htmlFor="files" className="file-upload-label">
                  Drag & drop files here or click to select
                </label>
                {formData.files.length > 0 && (
                  <div className="file-preview">
                    {formData.files.map((file, index) => (
                      <div key={index}>
                        {file.name} ({file.type})
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <button
              type="submit"
              className="button button-primary"
              disabled={isProcessing}
            >
              {isProcessing ? 'Uploading...' : 'Upload Tool'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
export default UploadTool;